export const APP_NAME = 'RAemChildrenSavingsCalculator'

export const trackingKeys = {
  initialDeposit: 'initialDeposit',
  monthlyDepositId: 'monthlyDeposit',
  age: 'age'
}
